import { Drawer } from 'antd';
import { NotificationContent } from 'features/notification/components/NotificationPanel/NotificationContent';
import { memo, type PropsWithChildren } from 'react';
import { OverlayPanelWrapper } from 'shared/components/Overlays';

export const NotificationOverlay = memo(({ children }: PropsWithChildren) => {
  return (
    <OverlayPanelWrapper
      renderOverlayPanel={(open, setOpen) => (
        <Drawer
          title={<span className="text-lg font-semibold">Thông báo</span>}
          placement="right"
          onClose={() => setOpen(false)}
          open={open}
          width={320}
          styles={{ body: { padding: '20px' } }}
        >
          <NotificationContent onClose={() => setOpen(false)} />
        </Drawer>
      )}
    >
      {children}
    </OverlayPanelWrapper>
  );
});
